<template>
    <div>
        <div class="article_name" >
            {{ article_info.article_name }}
        </div> 
        <div v-html="article_info.article_content" class="article_content" >
            
        </div>
    </div>
    
</template>
<script>
import { getArticle } from "../../api.js";
import { post } from "../../request.js";
import { Toast } from "vant";
export default {
    data() {
        return {
            loading: false,
            article_info: [],
            artId: ''
        }
    },
    created() {
        this.init()
    },
    methods: {
        init() {
        const that = this;
        that.loading = true;
        this.artId = this.$route.query.id;
        post(getArticle, { 'id': this.artId }).then(res => {
        that.loading = false;
        if (res.code == 200) {
            console.log(res.data);
          that.article_info = res.data.article_info;
        } else {
          Toast("网络错误");
        }
      });
    },
    },
}
</script>
<style lang="less" scoped>
    .article_content{
        padding: 0 1rem;
        p{
            img{
                width: 100%;
            }
        }
        
    }
    
    .article_name{
        text-align: center;
        padding-top: 1rem;
    }
</style>